import AppComponent from '../../mixins/app-component'

import AppIcon from '../app-icon'

export default
{
    name: 'app-team-single',

    mixins: [
        AppComponent
    ],

    components: {
        AppIcon
    },

    props: {
        member: { type: Object, default: {} },
        index: { type: Number, default: 0 },
        position: { type: String, default: '' }
    },

    data() {
        return {
            isShown: false,
            imageLoading: true
        }
    },

    created() {
        this.eventHub.$on('application:onEnterFrame', this.onEnterFrame)
        this.eventHub.$on('window:resize', this.onResize)

        this.top = null
        this.ready = false
    },

    mounted() {
        this.$loaderProgress = this.$el.querySelector('.js-loader-progress')
        
        this.image = {}
        this.image.$element = this.$refs.image
        this.image.bounding = null
        this.image.amplitude = this.$root.height * 0.05
    },

    destroyed() {
        this.eventHub.$off('application:onEnterFrame', this.onEnterFrame)
    },

    methods: {
        getImageSlugFromName() {
            const name = `${this.member.firstname} ${this.member.lastname}`
            return `${name.toLowerCase().replace(/\s+/g, '-')}`
        },

        onEnterFrame() {
            if (!this.ready) return
            
            // Reveal
            if (this.top < this.$root.currScrollTop + this.$root.height) {
                this.isShown = true
            } else if (this.isShown) {
                this.isShown = false
            }
            
            // Parallax
            if (!this.$root.isTouch)
            {
                let progress = (this.image.center - this.$root.currScrollTop) / this.$root.height
                progress = Math.min(Math.max(progress, -0.5), 1.5)
                progress -= 0.5
                progress *= -2
                
                const translateY = Math.round(progress * this.image.amplitude * 10) / 10
                
                this.image.$element.style.transform = `translateY(${translateY}px)`
            }
        },
        
        onResize() {
            this.top = this.$el.getBoundingClientRect().top + this.$root.currScrollTop
            
            if (!this.$root.isTouch) {
                const imageBounding = this.image.$element.getBoundingClientRect()
                this.image.center = imageBounding.top + this.$root.currScrollTop + imageBounding.height * 0.5
                
                this.image.amplitude = this.$root.height * 0.05
            }
        },

        _onLoad() {
            this.imageLoading = false
            
            this.$nextTick(() => {
                this.ready = true
                
                this.onResize()
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-team-single/script.js